import {connect} from 'react-redux'
import {adPageUrlSelector, adProductSelector, restoreOriginalDetails} from 'data/redux/selectors/productSelector';
import {AuthenticatedMapDispatchToProps, AuthenticatedMapStateToProps} from 'data/redux/containers/commons/Commons';
import {getLoadProductActionCreator, getUpdateProductActionCreator} from 'data/redux/actions/productsActions';
import {allProductTypes, autoAddAddons,} from 'data/redux/constants/productsConstants';
import EditProduct from 'gui/pages/controlRouter/pages/editProduct/EditProduct';
import {IProduct} from 'data/interfaces/products';
import {userIsAllowed} from 'data/redux/selectors/userSelector';
import {linksMap, USER_TYPE_ADMIN} from 'data/utils/constants';
import {navigateIfNotThere, navigateToPageExpectFor} from 'data/redux/actions/navigationActions';
import {isLoadingSelector} from 'data/redux/selectors/guiSelector';
import {getLoadInitialFiles} from "../../actions/documentsActions";

const mapStateToProps = (state, ownProps) => {
  const product = restoreOriginalDetails(adProductSelector(state));
  const {id}: any = adPageUrlSelector(state);
  return {
    id: parseInt(id || 0),
    product,
    isAdmin: userIsAllowed(USER_TYPE_ADMIN)(state),
    loading: isLoadingSelector(state),
    ...AuthenticatedMapStateToProps(state),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadProductPage: async (id: number) =>{
      return  dispatch(getLoadProductActionCreator(id, {
        $eager: `[${autoAddAddons(allProductTypes).join()},assets.[asset],saleDetails.currencyDetails,permissions.userDetails]`,
      } as any));
    },
    loadInitialFiles: (product_id) => dispatch(getLoadInitialFiles(product_id)),
    onSubmit: (product: IProduct) => dispatch(getUpdateProductActionCreator(product))
      .then(r => {
        
        dispatch(navigateToPageExpectFor(linksMap.adEditIdSlug));
        r.stop = true;
        return r;
      })
      .catch(e => {
        
        return Promise.resolve({error: true});
      }),
    setUrl: (path: string) => dispatch(navigateIfNotThere(path)),
    ...AuthenticatedMapDispatchToProps(dispatch),
    ...ownProps
  };
};


const EditProductContainer = connect(mapStateToProps, mapDispatchToProps)(EditProduct);

export default EditProductContainer;
